import { useCallback } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { updateWorkspace } from '../../../../services';
import { validateApiResponse } from '../../../../shared/utils/apiResponse';

/**
 * POST /v1/workspace/update with owner_email only (change owner flow).
 */
export function useUpdateWorkspaceOwner() {
  const { t } = useTranslation('workspaces');

  return useCallback(
    async (workspaceId, ownerEmail) => {
      const res = await updateWorkspace({
        workspace_uuid: workspaceId,
        owner_email: String(ownerEmail).trim(),
      });
      validateApiResponse(res, t('detail.changeOwnerModal.submitError'));
    },
    [t],
  );
}
